

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import { Binary } from '@angular/compiler';

export interface ProblemParameter extends Parameter {
    searchTerm: number;
    orderBy: string;

}

export interface Problem {
    departmentList?: any;
    id?: any;
    tenantId: any;
    branchId: any;
    name:any;
    code:string;
    department:any;
    
    parameters?: ProblemParameter[];
    links?: any;
}


export abstract class ProblemData {
    //abstract fireRequest(data: Department, method: string): Observable<any>;
    abstract list(url: string): Observable<Problem[]>;
    abstract create(url: string, data: Problem): Observable<Problem[]>;
    abstract update(url: string, data: Problem): Observable<Problem>;
    abstract delete(url: string): Observable<any>;
}
